import {useUpmPlant} from '@hconnect/upm'
import {Label} from '@hm/fundamental'
import moment from 'moment'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {useShutdowns} from '@refra/modules/common/providers'
import {getLocalizedYearDayMonthTime} from '@refra/modules/common/utils'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const KilnShutdownsLabel: React.FC = () => {
  const {
    t,
    i18n: {language}
  } = useTranslation()

  const plantCode = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId: plantCode})

  const {activeShutdowns} = useShutdowns()

  const newestShutdown = useMemo(() => {
    if (activeShutdowns.length === 0) return undefined

    return activeShutdowns.reduce((latest, current) => {
      return new Date(current.userInfo.updatedOn) > new Date(latest.userInfo.updatedOn)
        ? current
        : latest
    }, activeShutdowns[0])
  }, [activeShutdowns])

  const labelTitle =
    newestShutdown !== undefined
      ? t('common.lastSavedBy', {
          date: getLocalizedYearDayMonthTime(
            moment(newestShutdown.userInfo.updatedOn),
            upmPlant.timezone,
            language
          ),
          name: newestShutdown.userInfo.updatedBy
        })
      : ''

  return (
    <Label
      title={labelTitle}
      {...{children: t('refraPlanning.kilnShutdown.title')}}
      inverted
      data-cy="kiln_shutdowns_card_label"
    />
  )
}
